import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestExpenses } from "../../entity/EntityRequestExpenses";

export class DtoRequestExpensessGetRes extends EntityRequestExpenses {
  public items: EntityRequestExpenses[]  = [];
}
